import { ChangeDetectorRef, Component, OnInit, Output, EventEmitter, Input, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NotificationService } from "@progress/kendo-angular-notification";
import { CommonService } from "app/reusable/common.service";
import { MidOfficeDiagnose } from "app/_models/mid-office-diagnose.model";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CedNotificationService } from 'ced-ng-library';
import { environment } from "environments/environment";

@Component({
  selector: "app-add-mid-office-diagnose",
  templateUrl: "./add-mid-office-diagnose.component.html",
  styleUrls: ["./add-mid-office-diagnose.component.scss"],
})
export class AddMidOfficeDiagnoseComponent implements OnInit, OnDestroy {
  showGrid = true;
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() id: string;
  public midOfficeDiagnose = new MidOfficeDiagnose();
  public icdDiagnoseNbr: number = 0;
  public activeIcdDiagnose: number = 0;
  public midOfficeDiagnoseForm: FormGroup;
  data: MidOfficeDiagnose;
  dislpayDetails = false;
  private _subject$: Subject<boolean> = new Subject();

  constructor(
    private commonService: CommonService,
    private cedNotificationService: CedNotificationService
  ) { }

  ngOnInit() {
    this.initForm();
    this.id ? this.getMidOfficeById() : (this.dislpayDetails = true);
  }

  private initForm() {
    this.midOfficeDiagnoseForm = new FormGroup({
      modCode: new FormControl(""),
      modType: new FormControl("", [Validators.required]),
      modIsActive: new FormControl(true),
      modComment: new FormControl(""),
    });
  }

  getMidOfficeById() {
    let GetMidOfficeByIdUrl = `MidOfficeDiagnose/GetById/${this.id}`;
    this.commonService.getData(GetMidOfficeByIdUrl, this.serverUrlSlot3).pipe(takeUntil(this._subject$)).subscribe((data) => {
      this.data = data as MidOfficeDiagnose;
      this.midOfficeDiagnoseForm.patchValue(this.data);
      this.midOfficeDiagnose.icdDiagnoses = this.data.icdDiagnoses;
    });
  }

  public icdDiagnoses(event) {
    for (let i = 0; i < event.length; i++) {
      if (event[i].icdIsActive == true) {
        this.activeIcdDiagnose++;
      }
    }
    this.icdDiagnoseNbr = event.length;
    this.midOfficeDiagnose.icdDiagnoses = event;
  }

  public CreateMidOfficeDiagnose = (MidOfficeDiagnoseFormValue) => {

    if (this.midOfficeDiagnoseForm.invalid) {
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING");
      return;
    }

    if(this.icdDiagnoseNbr == 0){
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_ICD");
      return;
    }
    
    if(this.activeIcdDiagnose == 0){
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_ACTIV_ICD");
      return;
    }

    if (this.midOfficeDiagnoseForm.valid && this.icdDiagnoseNbr != 0 && this.activeIcdDiagnose > 0) {
      this.midOfficeDiagnose.modType = MidOfficeDiagnoseFormValue.modType;
      this.midOfficeDiagnose.modIsActive = MidOfficeDiagnoseFormValue.modIsActive;
      this.midOfficeDiagnose.modComment = MidOfficeDiagnoseFormValue.modComment;
      if (this.id != undefined) {
        this.midOfficeDiagnose.modId = this.id;
        this.midOfficeDiagnose.modCode = MidOfficeDiagnoseFormValue.modCode;
        let UpdateMidOfficeDiagnoseUrl: string = `MidOfficeDiagnose/Update`;
        this.commonService.update(
          UpdateMidOfficeDiagnoseUrl,
          this.midOfficeDiagnose
        ).pipe(takeUntil(this._subject$)).subscribe((res) => {
          let midOfficeDiagnose = res as any;
          this.save.emit(midOfficeDiagnose);
          this.close();
        });
        this.cedNotificationService.success("NOTIFICATIONS.DATA_UPDATED");
      }
      else {
        let PostMidOfficeDiagnoseUrl: string = `MidOfficeDiagnose/Post`;
        this.commonService.create(
          PostMidOfficeDiagnoseUrl,
          this.midOfficeDiagnose
        ).pipe(takeUntil(this._subject$)).subscribe((res) => {
          let midOfficeDiagnose = res as any;
          this.save.emit(midOfficeDiagnose);
          this.cedNotificationService.success("NOTIFICATIONS.DATA_SAVED");
          this.close();
        });
      }
    }
  };

  close() {
    this.cancel.emit(true);
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}